import React, { useEffect } from 'react';

const PaymentMethod = ({ onChange }) => {
    useEffect(() => {
        if (onChange) {
            onChange('CK');
        }
    }, []);

    return (
        <div className="payment-order box float-left">
            <h3 className="title-brand">PHƯƠNG THỨC THANH TOÁN</h3>
            <ul className="tabs">
                <li onClick={() => onChange('CK')} className="active">
                    <i className="icon"></i>
                    <h4>Chuyển khoản</h4>
                    <p>
                        Số tài khoản: 0123456789
                        <br />
                        Chủ tài khoản: LisaFood
                        <br />
                        Ngân hàng Thương Mại Cổ Phần Nam Á
                        <br />
                    </p>
                </li>
                <li onClick={() => onChange('COD')}>
                    <i className="icon"></i>
                    <h4>Trả tiền khi nhận hàng (COD)</h4>
                </li>
            </ul>
        </div>
    );
};

export default PaymentMethod;
